<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="#d98880">
                            <v-toolbar-title class="my-0 py-0">REGISTRO DE AUTOINSPECCIÓN DE PROCESOS (EI
                                057)</v-toolbar-title>
                            <v-spacer></v-spacer>
                            CÓDIGO: {{ codigo }}
                            <v-spacer></v-spacer>
                            <v-btn icon @click="exportarPDF()">
                                <v-icon>mdi-file-pdf-box</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="6">
                                    <h6> Cliente: {{ cliente }}</h6>
                                </v-col>
                                <v-col cols="6" sm="6" md="4">
                                    Obra: {{ obra }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    N° de Obra: {{ numobra }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="4">
                                    Proceso: {{ proceso }}
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    Referencia: {{ referencia }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    N° de OT: {{ numot }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    Cantidad: {{ cantidad }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="orange lighten-4">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-data-table :headers="headersTabla" :items="listado" :items-per-page="200"
                                        hide-default-footer dense>
                                        <template v-slot:item.auditoria="{ item }">
                                            <div class="d-flex justify-center">
                                                <v-checkbox v-model="item.auditoria" true-value="ON" hide-details dense
                                                    color="red"></v-checkbox>
                                            </div>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    Aprobó especificación: {{ aproboesp }}
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    Fecha: {{ fechaesp }}
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    Aprobó inspección: {{ aproboinsp }}
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    Fecha: {{ fechainsp }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    Observaciones: {{ observ }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    data: (vm) => ({
        deshabilitar: false,
        usuario: "",
        valid: false,
        lazy: false,
        codigo: "",
        codgral: "",
        cliente: "",
        codreg: "",
        obra: "",
        cantidad: "1",
        listadocliente: [],
        listadoobra: [],
        listado: [],
        listadodetalle: [],
        numobra: "",
        proceso: "",
        referencia: "",
        numot: "",
        aproboesp: "",
        aproboinsp: "",
        fechaesp: "",
        fechainsp: "",
        observ: "",
        selectAll: {
            autoinsp: false,
            auditoria: false,
        },
        titulosColumnas: [],

    }),
    props: ["visible", "codint"],
    computed: {
        // Construye los headers dinámicamente según titulosColumnas
        headersTabla() {
            const base = [
                { text: "Item", align: "start", sortable: false, width: "10%", value: "item" },
                { text: "Auditoría", value: "auditoria", align: "center", sortable: false },
                { text: "Característica", value: "caracteristica", align: "left", sortable: false },
            ];
            const cant = parseInt(this.cantidad) || 1;
            for (let i = 0; i < cant; i++) {
                const titulo = (this.titulosColumnas && this.titulosColumnas[i])
                    ? this.titulosColumnas[i]
                    : `Columna ${i + 1}`;
                base.push({ text: titulo, value: `col${i + 1}`, align: "center", sortable: false });
            }
            return base;
        },

        show: {
            get() {
                if (this.visible == true) {
                    this.cargarlistado();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {

                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        cargarlistado() {
            this.loadtable = true;
            let self = this;

            axios
                .get("/Ingenieria/CargarEI057?", {
                    params: {
                        codint: self.codint
                    },
                })
                .then((response) => {
                    self.cliente = response.data.cliente;
                    self.codigo = response.data.codigo;
                    self.obra = response.data.obra;
                    self.numobra = response.data.numobra;
                    self.numot = response.data.numot;
                    self.proceso = response.data.proceso;
                    self.referencia = response.data.referencia;
                    self.cantidad = response.data.cantidad;
                    self.aproboesp = response.data.aproboesp;
                    self.fechaesp = response.data.fechaesp;
                    self.aproboinsp = response.data.aproboinsp;
                    self.fechainsp = response.data.fechainsp;
                    self.observ = response.data.observ;
                    self.listado = response.data.detalles;
                    self.titulosColumnas = (response.data.columnas || []).map(c => c.descr || c.Descr || c);
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];

                    console.log(error);
                });
        },


        vaciarListado() {
            this.codigo = "";
            this.codgral = "";
            this.cliente = "";
            this.obra = "";
            this.cantidad = "1";
            this.listadocliente = [];
            this.listadoobra = [];
            this.listado = [];
            this.listadodetalle = [];
            this.numobra = "";
            this.proceso = "";
            this.referencia = "";
            this.numot = "";
            this.aproboesp = "";
            this.aproboinsp = "";
            this.fechaesp = "";
            this.fechainsp = "";
            this.observ = "";
        },

        // exportarPDF() {
        //     const vm = this;
        //     const doc = new jsPDF('landscape');

        //     function dibujarEncabezado(doc) {
        //         doc.setLineWidth(0.5);
        //         doc.line(10, 11, 285, 11);
        //         doc.line(10, 11, 10, 41);
        //         doc.line(40, 26, 285, 26);

        //         doc.addImage("foto", "JPEG", 15, 15, 22, 22);
        //         doc.setFontSize(12);
        //         doc.text("PLANILLA DE AUTOINSPECCIÓN DE PROCESOS", 65, 20);
        //         doc.setFontSize(9);
        //         doc.text("Cliente: " + vm.cliente, 55, 29);
        //         doc.text("Proceso: " + vm.proceso, 55, 32);
        //         doc.text("Referencia: " + vm.referencia, 55, 35);
        //         doc.text("Obra: " + vm.obra, 55, 38);
        //         doc.setFontSize(10);
        //         doc.text("Código: " + vm.codigo, 240, 20);
        //         doc.text("N° de OT: " + vm.numot, 235, 35);
        //         doc.line(40, 11, 40, 41);
        //         doc.line(220, 11, 220, 41);
        //         doc.line(10, 41, 285, 41);
        //         doc.line(285, 11, 285, 41);
        //         doc.setFontSize(9);
        //     }

        //     dibujarEncabezado(doc);

        //     const columnasFijas = [
        //         { title: "Item", dataKey: "item" },
        //         { title: "Descripción", dataKey: "caracteristica" },
        //         { title: "Autoinspección", dataKey: "autoinsp" },
        //         { title: "Auditoría", dataKey: "auditoria" },
        //     ];

        //     const cantidadTotal = vm.cantidad;
        //     const maxParesPorBloque = 6;
        //     const bloques = Math.ceil(cantidadTotal / maxParesPorBloque);

        //     for (let b = 0; b < bloques; b++) {
        //         const dynamicColumns = [];
        //         const inicio = b * maxParesPorBloque + 1;
        //         const fin = Math.min(inicio + maxParesPorBloque - 1, cantidadTotal);

        //         for (let i = inicio; i <= fin; i++) {
        //             dynamicColumns.push({ title: "Control " + i, dataKey: "control" + i });
        //             dynamicColumns.push({ title: "Medición " + i, dataKey: "medicion" + i });
        //         }

        //         const allColumns = columnasFijas.concat(dynamicColumns);

        //         // Column widths
        //         let columnStyles = {
        //             0: { columnWidth: 10 },  // Item
        //             1: { columnWidth: 40 },  // Descripción
        //             2: { columnWidth: 15 },  // Autoinspección
        //             3: { columnWidth: 15 },  // Auditoría
        //         };

        //         // Column widths for dynamic columns
        //         for (let i = 4; i < allColumns.length; i++) {
        //             columnStyles[i] = { columnWidth: 15 };
        //         }

        //         doc.autoTable({
        //             columns: allColumns,
        //             body: vm.listado,
        //             theme: 'grid',
        //             startY: 50,
        //             columnStyles: columnStyles,
        //             styles: {
        //                 fontSize: 7,
        //                 textColor: [0, 0, 0],
        //             },
        //             didDrawPage: function () {
        //                 dibujarEncabezado(doc);
        //             }
        //         });

        //         if (b < bloques - 1) {
        //             doc.addPage();
        //             dibujarEncabezado(doc);
        //         }
        //     }

        //     doc.output('dataurlnewwindow');
        //     doc.save("Plan" + vm.filtroperiodo + ".pdf");
        // },
        // exportarPDF() {
        //     const vm = this;
        //     const doc = new jsPDF('landscape');

        //     function dibujarEncabezado(doc) {
        //         doc.setLineWidth(0.5);
        //         doc.line(5, 6, 280, 6);
        //         doc.line(5, 6, 5, 31);
        //         doc.line(35, 16, 280, 16);

        //         doc.addImage("/9j/4AAQSkZJRgABAQEBLAEsAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCABHAEUDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD3+qeq6rY6Hpdxqep3MdtZ26b5ZX6KP5kk4AA5JIAyTRquq2Oh6XcanqdzHbWdum+WV+ij+ZJOAAOSSAMk18kfEz4mX3j/AFQIgkttFt3JtbQnknp5kmOC5HbooOB1JYA7DVf2kNebVLg6PpWmpp+/EAu43aXb6sVcDJ64HTOMnGTT/wCGjvGH/QN0P/vxN/8AHa8fooA9g/4aO8Yf9A3Q/wDvxN/8dru9N+LOvaX4ObxR4ytNNtoLtCNI061jdLi9bg7yWdgkQBHJHIIPdQ/jGlaVY+FdLt/EfiO2jubq4TzNI0aXpOO1xOOogB+6vWQjsoJOH4n8T6p4u1ybV9Xn824k4VV4SJB0RB2UZP5kkkkkgHpH/DR3jD/oG6H/AN+Jv/jtdP4C+Pd/rnii00fX9PsYo76VYYbi0Ei+W5BCgqS+7c2xeq4yScjp88V6p4L0qx8FeKvDw1q2juvE1/e2yw6fL93TYndR5sw/57lTlE/gyGbnaKAPquiiigD5s/aQ1W+bxVpmjm5k/s9LJboW44XzWeRS59TtUAZ6c4xk58Tr2D9o7/koen/9gqP/ANGy14/QB9H/AAt+Fvg3xH8ONJ1bVtG+0X0/neZL9qmTdtmdRwrgDgAcCu0g+DHw+triKdPDsZeNw6iS5mdSQc8qzkMPYgg96+VLHxZ4k0yzjs7DxBqtpax52QwXskaLkknCg4GSSfxqx/wnfjD/AKGvXP8AwYzf/FUAfVeq/CfwVrmqXGp6npElzeXD75ZXvbjLH/vvAAGAAOAAAMAVy/i/4IeD/wDhFdRn0bSru31C2t5J4Ba3EkjTOqMVjKuWyC2OAAemDXgEHjTxtdXEVvb+JfEE08rhI447+ZmdicAABskk8Yr6D0fwz4k8K/DHxDquv+ItVu9dk0q4dUe/kkSyxGzAL82DICAS46YwvGSwB4x9uT4X/uNOkgn8ZHi6uwqyx6WO8Mecq8x6O/IUZRcncaw/Bc8118S/D1xcSyTTy6xbPJJIxZnYzKSSTySTzmubroPAn/JQ/DX/AGFbX/0atAH2/RRRQB8wftHf8lD0/wD7BUf/AKNlrx+vYP2jv+Sh6f8A9gqP/wBGy14/QAVJBBNdXEVvbxSTTyuEjjjUszsTgAAckk8Yr6j+EHizw3pnwt0azv8AxBpVpdR+fvhnvY43XM8hGVJyMgg/jXcf8J34P/6GvQ//AAYw/wDxVAHF/Cb4TQ+DbdNY1hI5vEEqcDIZbNSOVU9C5HDMP90cZLdp47/5J54l/wCwVdf+imo/4Tvwf/0Neh/+DGH/AOKrL8U+JdB1nwL4nt9L1vTb6ddHu3aO1uklYL5TDJCknGSBn3FAHxpXQeBP+Sh+Gv8AsK2v/o1a5+ug8Cf8lD8Nf9hW1/8ARq0Afb9FFFAHzB+0d/yUPT/+wVH/AOjZa8fr6H+Nfw78VeLvGVnf6HpX2u1j09IWf7RFHhxJISMOwPRh+decf8KS+If/AEL3/k7b/wDxygDH+Hfhuz8XeO9N0O/knjtbrzd7wMA42xO4wSCOqjtXs+pfAz4f6Rv+3a1rkWy0mvW/eRtiGHb5jcQnpvXjqc8A81gfC34W+MvDnxH0nVtW0b7PYwed5kv2qF9u6F1HCuSeSBwK9j8U6BfaxrmmXFosYS0t5H3SNhTKt1ZzxxnGSA3kONwB29cHgEA8vHwf+G5t3lOreJ0dHVPs0kBS4YsCRtgNuJGBCucqpGEc/wADY2NE8K+DdK8NX1jovifxB9j1J5rW8trexjmumKDZIjoLUzIF3AcgBTIDwXGe01uTWdY06KRfCs4jgu4y1vJfpBeFCHV3geKTajDcvWQb181SFBBbn10bxU+k28epWOq3kIluIIZIdUii1azgMaLExlQxxyZaNmdCzctESXKGgDm2+Cfw5TS9O1J9f1lLTUnhSzdpowZmmx5YVTFnJznGOBknABxsW/wo0b4eXdn4g0TUNSN4t7aW2LryJVMc1xHFIBmLKkq7DcpB5POCQdCTwx4r8R2UOnahPHYW1vo/2TzL2EXjyyzoVkbcs4zLHGFj80qNxkmIUK2K6DXZL6XwfpzanDHDfjU9NW4WI5QuL2EFk5J2EjK55wRkA5AAOsooooAKKKKAK99ZRahZyWszzpG+MmCd4XGCDw6EMOnY89OlY/8Awhul/wDP1rn/AIPb3/49RRQAf8Ibpf8Az9a5/wCD29/+PUf8Ibpf/P1rn/g9vf8A49RRQAf8Ibpf/P1rn/g9vf8A49QPBmkebDJI+qzeTKkyJPrF3Km9GDqSjSlThlB5B6UUUAdBRRRQB//Z",
        //             "JPEG", 10, 10, 17, 17);
        //         doc.setFontSize(12);
        //         doc.text("PLANILLA DE AUTOINSPECCIÓN DE PROCESOS", 60, 12);
        //         doc.setFontSize(9);
        //         doc.text("Cliente: " + vm.cliente, 55, 20);
        //         doc.text("Proceso: " + vm.proceso, 55, 23);
        //         doc.text("Referencia: " + vm.referencia, 55, 26);
        //         doc.text("Obra: " + vm.obra, 55, 29);
        //         doc.setFontSize(10);
        //         doc.text("Código: " + vm.codigo, 226, 12);
        //         doc.text("N° de OT: " + vm.numot, 226, 25);
        //         doc.line(35, 6, 35, 31);
        //         doc.line(215, 6, 215, 31);
        //         doc.line(5, 31, 280, 31);
        //         doc.line(280, 6, 280, 31);
        //         doc.setFontSize(9);
        //     }

        //     dibujarEncabezado(doc);

        //     const columnasFijas = [
        //         { title: "Item", dataKey: "item" },
        //         { title: "Descripción", dataKey: "caracteristica" },
        //         { title: "Autoinsp.", dataKey: "autoinsp" },
        //         { title: "Auditoría", dataKey: "auditoria" },
        //     ];

        //     const cantidadTotal = vm.cantidad;
        //     const maxParesPorBloque = 6;
        //     const bloques = Math.ceil(cantidadTotal / maxParesPorBloque);

        //     for (let b = 0; b < bloques; b++) {
        //         const dynamicColumns = [];
        //         const inicio = b * maxParesPorBloque + 1;
        //         const fin = Math.min(inicio + maxParesPorBloque - 1, cantidadTotal);

        //         for (let i = inicio; i <= fin; i++) {
        //             dynamicColumns.push({ title: "Ref. Eq. " + i, dataKey: "control" + i });
        //             dynamicColumns.push({ title: "Med. Eq. " + i, dataKey: "medicion" + i });
        //         }

        //         const allColumns = columnasFijas.concat(dynamicColumns);

        //         let columnStyles = {
        //             0: { columnWidth: 10 },
        //             1: { columnWidth: 50 },
        //             2: { columnWidth: 15 },
        //             3: { columnWidth: 15 },
        //         };

        //         for (let i = 4; i < allColumns.length; i++) {
        //             columnStyles[i] = { columnWidth: 16 };
        //         }


        //         doc.autoTable({
        //             columns: allColumns,
        //             body: vm.listado,
        //             theme: 'grid',
        //             startY: 40,
        //             margin: { top: 40, left: 5 },
        //             columnStyles: columnStyles,
        //             styles: {
        //                 fontSize: 7,
        //                 textColor: [0, 0, 0],
        //             },
        //             didDrawPage: function () {
        //                 dibujarEncabezado(doc);
        //             },
        //             didParseCell: function (data) {
        //                 if (
        //                     data.section === 'body' &&
        //                     (data.column.dataKey === 'autoinsp' || data.column.dataKey === 'auditoria') &&
        //                     data.cell.raw === 'ON'
        //                 ) {
        //                     data.cell.text = ['Si'];
        //                 }
        //             }
        //         });


        //         if (b < bloques - 1) {
        //             doc.addPage();
        //             dibujarEncabezado(doc);
        //         }
        //     }

        //     doc.output('dataurlnewwindow');
        //     doc.save("Plan" + vm.filtroperiodo + ".pdf");
        // },

        exportarPDF() {
            const vm = this;

            // 1) Orientación dinámica: vertical si 1 o 2 columnas, horizontal si más
            const orientation = (Number(vm.cantidad) <= 2) ? "portrait" : "landscape";

            // Recomiendo definir formato/unidad para que sea consistente (A4 mm)
            const doc = new jsPDF({ orientation, unit: "mm", format: "a4" });

            function dibujarEncabezado(doc) {
                const pageWidth = doc.internal.pageSize.getWidth();
                const left = 5;
                const right = pageWidth - 5;

                // Layout
                const headerTopY = 6;
                const headerBottomY = 31;

                // Logo
                const logoX = 10;
                const logoY = 10;
                const logoW = 17;
                const logoH = 17;

                // Columnas de encabezado
                const splitLeftX = 35;       // línea vertical después del logo
                const splitRightX = right - 65; // bloque derecho (Código / OT)

                // Líneas del marco
                doc.setLineWidth(0.5);
                doc.line(left, headerTopY, right, headerTopY);
                doc.line(left, headerTopY, left, headerBottomY);
                doc.line(right, headerTopY, right, headerBottomY);
                doc.line(left, headerBottomY, right, headerBottomY);

                // Separadores
                doc.line(splitLeftX, headerTopY, splitLeftX, headerBottomY);
                doc.line(splitRightX, headerTopY, splitRightX, headerBottomY);
                doc.line(splitLeftX, 16, right, 16);

                // Logo ICSSA
                try {
                    doc.addImage("images/ICSSA.jpg", "JPEG", logoX, logoY, logoW, logoH);
                } catch (e) { /* logo no disponible */ }

                // Título centrado entre splitLeftX y splitRightX
                const title = "PLANILLA DE AUTOINSPECCIÓN DE PROCESOS";
                doc.setFontSize(12);

                const titleAreaLeft = splitLeftX + 2;
                const titleAreaRight = splitRightX - 2;
                const titleAreaWidth = titleAreaRight - titleAreaLeft;

                const textWidth = doc.getTextWidth(title);
                const titleX = titleAreaLeft + Math.max((titleAreaWidth - textWidth) / 2, 0);

                doc.text(title, titleX, 12);

                // Datos del cliente (lado medio)
                doc.setFontSize(9);
                doc.text("Cliente: " + (vm.cliente ?? ""), titleAreaLeft, 20);
                doc.text("Proceso: " + (vm.proceso ?? ""), titleAreaLeft, 23);
                doc.text("Referencia: " + (vm.referencia ?? ""), titleAreaLeft, 26);
                doc.text("Obra: " + (vm.obra ?? ""), titleAreaLeft, 29);

                // Bloque derecho alineado a la derecha
                doc.setFontSize(10);
                const rightPadding = 2;
                const codigoText = "Código: " + (vm.codigo ?? "");
                const otText = "N° de OT: " + (vm.numot ?? "");

                doc.text(codigoText, right - rightPadding, 12, { align: "right" });
                doc.text(otText, right - rightPadding, 25, { align: "right" });
            }


            dibujarEncabezado(doc);

            const columnasFijas = [
                { title: "Item", dataKey: "item" },
                { title: "Descripción", dataKey: "caracteristica" },
                { title: "Auditoría", dataKey: "auditoria" },
            ];

            const cantidadTotal = Number(vm.cantidad) || 0;
            const maxParesPorBloque = 5;
            const bloques = Math.ceil(cantidadTotal / maxParesPorBloque);

            for (let b = 0; b < bloques; b++) {
                const dynamicColumns = [];
                const inicio = b * maxParesPorBloque + 1;
                const fin = Math.min(inicio + maxParesPorBloque - 1, cantidadTotal);

                for (let i = inicio; i <= fin; i++) {
                    const titulo = (vm.titulosColumnas && vm.titulosColumnas[i - 1])
                        ? vm.titulosColumnas[i - 1]
                        : `Col ${i}`;
                    dynamicColumns.push({ title: titulo + "\nAutoInsp.", dataKey: `col${i}` });
                    dynamicColumns.push({ title: titulo + "\nAuditoría", dataKey: `aud${i}` });
                }

                const allColumns = columnasFijas.concat(dynamicColumns);


                const pageWidth = doc.internal.pageSize.getWidth();
                const marginLeft = 5;
                const marginRight = 5;
                const availableWidth = pageWidth - marginLeft - marginRight;

                // Fijas: podés ajustar estos mínimos a tu gusto
                const wItem = 8;
                const wDesc = (orientation === "portrait") ? 50 : 45; // un poquito más en vertical
               // const wAuto = 15;
               // const wAudit = 15;

                const fixedWidth = wItem + wDesc + 15;
                const dynamicCount = Math.max(allColumns.length - 3, 1);
                const dynamicWidth = Math.max((availableWidth - fixedWidth) / dynamicCount, 10); // mínimo 10mm

                let columnStyles = {
                    0: { columnWidth: wItem, halign: 'center' },
                    1: { columnWidth: wDesc, fontSize: 10 },
                    2: { columnWidth: 15, halign: 'center' },
                };


                //for (let i = 3; i < allColumns.length; i++) {
                //    columnStyles[i] = { columnWidth: dynamicWidth };
                //}
                for (let i = 3; i < allColumns.length; i++) {
                    columnStyles[i] = { columnWidth: dynamicWidth, halign: 'center' };
                }

                // Agregar filas de Firma, Aclaración, Fecha al final
                const filasExtra = [];
                const sigLabels = ["Firma:", "Aclaración:", "Fecha:"];
                sigLabels.forEach((label) => {
                    const fila = { item: "", caracteristica: label, auditoria: "" };
                    for (let i = inicio; i <= fin; i++) {
                        fila[`col${i}`] = "";
                        fila[`aud${i}`] = "";
                    }
                    filasExtra.push(fila);
                });
                const bodyConFirma = [...vm.listado, ...filasExtra];

                doc.autoTable({
                    columns: allColumns,
                    body: bodyConFirma,
                    theme: "grid",
                    startY: 40,
                    margin: { top: 40, left: marginLeft, right: marginRight },
                    tableWidth: "auto",
                    columnStyles,
                    headStyles: {
                        halign: 'center',
                        valign: 'middle',
                        fontSize: 8,
                        fillColor: [30, 63, 122],
                        textColor: [255, 255, 255],
                    },
                    styles: {
                        fontSize: 9,
                        textColor: [0, 0, 0],
                        cellWidth: "wrap",
                    },
                    didDrawPage: function () {
                        dibujarEncabezado(doc);
                    },
                    didParseCell: function (data) {
                        if (data.section === "body" && data.cell.raw === "ON") {
                            data.cell.text = ["Si"];
                        }
                    },

                    // didParseCell: function (data) {
                    //     if (
                    //         data.section === "body" &&
                    //         data.column.dataKey === "auditoria" &&
                    //         data.cell.raw === "ON"
                    //     ) {
                    //         data.cell.text = ["Si"];
                    //     }
                    // },
                });

                if (b < bloques - 1) {
                    doc.addPage();
                    dibujarEncabezado(doc);
                }
            }

            // Aprobaciones al final del PDF
            const finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 15 : 200;
            const pw = doc.internal.pageSize.getWidth();
            doc.setFontSize(9);
            doc.text("Aprobó Especificación: " + (vm.aproboesp || "........................................"), 10, finalY);
            doc.text("Fecha: " + (vm.fechaesp || "...../...../.........."), pw / 2 + 10, finalY);
            doc.text("Aprobó Inspección: " + (vm.aproboinsp || "........................................"), 10, finalY + 10);
            doc.text("Fecha: " + (vm.fechainsp || "...../...../.........."), pw / 2 + 10, finalY + 10);

            doc.output("dataurlnewwindow");
            doc.save("Plan" + vm.filtroperiodo + ".pdf");
        },

    },
};
</script>